<template>
  <li class="item articleResult">
    <a :href="result.url" class="card">
      <div class="preview">
        <picture>
          <source
            :srcset="
              isPreviewItem
                ? result?.images?.previewImage?.url.toCropUrl(420, 460) ||
                  defaultSiteImageUrl.toCropUrl(420, 460)
                : result?.images?.previewImage?.url.toCropUrl(420, 460) ||
                  defaultSiteImageUrl.toCropUrl(420, 460)
            "
            media="(min-width: 1050px)"
          />
          <source
            :srcset="
              result?.images?.previewImage?.url.toCropUrl(450, 430) ||
                defaultSiteImageUrl.toCropUrl(450, 430)
            "
            media="(min-width: 500px)"
          />
          <source
            :srcset="
              result?.images?.previewImage?.url.toCropUrl(210, 230) ||
                defaultSiteImageUrl.toCropUrl(210, 230)
            "
            media="(min-width: 0px)"
          />
          <img
            :src="
              isPreviewItem
                ? result?.images?.previewImage?.url.toCropUrl(210, 230) ||
                  defaultSiteImageUrl.toCropUrl(210, 230)
                : result?.images?.previewImage?.url.toCropUrl(210, 230) ||
                  defaultSiteImageUrl.toCropUrl(210, 230)
            "
            :alt="result?.images?.previewImage?.altText"
          />
        </picture>
      </div>

      <div class="content">
        <div class="tag" v-if="result?.additionalFields.previewTag">
          {{ result?.additionalFields.previewTag }}
        </div>

        <div class="heading">
          <span v-if="result?.additionalFields.previewTitle">
            {{ result?.additionalFields.previewTitle }}
          </span>
        </div>

        <div class="articleDetails">
          <div class="avatar" v-if="result?.additionalFields.authorImage">
            <img
              :src="result?.additionalFields.authorImage"
              alt="author portrait"
            />
          </div>

          <div class="details">
            <p class="name" v-if="result?.additionalFields.authorName">
              {{ result?.additionalFields.authorName }}
            </p>

            <p class="dateTime">
              <span v-if="result?.additionalFields.displayDate">
                {{ result?.additionalFields.displayDate }}
              </span>
              <span v-if="result?.additionalFields.readTime">
                {{ result?.additionalFields.readTime }}
              </span>
            </p>
          </div>
        </div>
      </div>
    </a>
  </li>
</template>
<script lang="ts">
import { defineComponent, PropType } from "vue";
import { ISiteSearchResultItem } from "../../clients/search/src/models";

export default defineComponent({
  props: {
    result: {
      type: Object as PropType<ISiteSearchResultItem>,
      required: true,
      default: (): ISiteSearchResultItem => {
        return {};
      }
    },
    language: {
      type: String,
      required: false,
      default: ""
    },
    index: {
      type: Number,
      required: true
    },
    defaultSiteImageUrl: {
      type: String,
      required: true,
      default: ""
    }
  },
  computed: {
    resultUrl() {
      const urlParts: string[] = [window.location.origin, this.result?.url];

      return urlParts
        .map((url) => (url ? url.replace(/^\/+|\/+$/g, "") : ""))
        .join("/");
    },
    isPreviewItem() {
      return (
        this.index === 0 ||
        this.index === 6 ||
        this.index === 10 ||
        this.index === 16 ||
        this.index === 20
      );
    }
  }
});
</script>
